import { useEffect, useState } from "react";
import axios from "axios";
import { server } from "../server";

const Gallery = () => {
   const [gallery, setGallery] = useState([]);
  

  // Fetch user's gallery on component mount
    const fetchGallery = async () => {
      try {
        const token = localStorage.getItem("token");
        const { data } = await axios.get(`${server}/images/user-gallery`, {
          headers: { Authorization: token },
        });
        setGallery(data);
      } catch (error) {
        console.error("Error fetching gallery:", error);
      }
    };
  
    // Use useEffect to call fetchGallery on component mount
    useEffect(() => {
      fetchGallery();
    }, []); // Empty dependency array ensures this runs only once on mount


    
      // Delete an image
      const deleteImage = async (id) => {
        try {
          const token = localStorage.getItem("token");
          console.log("Deleting image with ID:", id); // Debugging
          await axios.delete(`${server}/images/delete/${id}`, {
            headers: { Authorization: token },
          });
      
          // Refresh the gallery after deletion
          fetchGallery();
        } catch (error) {
          console.error("Error deleting image:", error.response?.data);
          alert(`Error: ${error.response?.data?.message || "Failed to delete image"}`);
        }
      };
      
    
    
      // Download an image
      const downloadImage = async (url) => {
        try {
          // Fetch the image as a blob
          const response = await fetch(url);
          const blob = await response.blob();
      
          // Create a temporary link element
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `image_${Date.now()}.jpg`; // Set the filename
          document.body.appendChild(link);
      
          // Trigger the download
          link.click();
      
          // Clean up
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
        } catch (error) {
          console.error("Error downloading image:", error);
          alert("Failed to download image. Please try again.");
        }
      };
    
      // Share an image
      const shareImage = async (url) => {
        try {
          if (navigator.share) {
            await navigator.share({
              title: "Check out this image!",
              url: url,
            });
          } else {
            // Fallback for browsers that don't support Web Share API
            alert("Sharing is not supported in your browser. Copy the URL manually.");
          }
        } catch (error) {
          console.error("Error sharing image:", error);
        }
      };



  return (
    <div className="mt-12">
  <h2 className="text-xl font-bold mb-4 text-center">Your Gallery</h2>
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
    {gallery.map((img) => {
      console.log("Image object:", img); // Debugging
      return (
        <div key={img._id} className="border p-4">
          <img src={img.imageURL} alt={img.prompt} className="mb-2" />
          <div className="flex gap-2">
            <button
              className="bg-red-500 text-white p-2"
              onClick={() => deleteImage(img._id)}
            >
              Delete
            </button>
            <button
              className="bg-green-500 text-white p-2"
              onClick={() => downloadImage(img.imageURL)}
            >
              Download
            </button>
            <button
              className="bg-purple-500 text-white p-2"
              onClick={() => shareImage(img.imageURL)}
            >
              Share
            </button>
          </div>
          <p>{img.prompt}</p>
        </div>
      );
    })}
  </div>
</div>
  );
};

export default Gallery;